import React from "react";

import { LegendItemProps } from "./LegendItem.types";
import { useStyles } from "./LegendItem.styles";
import { Typography } from "..";

function LegendItem(props: LegendItemProps) {
  const { children } = props;

  const classes = useStyles(props);

  return (
    <Typography
      component="li"
      variant={"h4"}
      fontWeight="semiBold"
      className={classes.root}
      color="grey"
      tone={900}
    >
      {children}
    </Typography>
  );
}

export default LegendItem;
